// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Icon, Rating, Label } from 'semantic-ui-react';
import type { Thread } from '../../types';

type Props = {
  thread: Thread,
  hasNewMessage: boolean,
  onTrack: (value: boolean) => void,
  onHideNewMessage: () => void,
};

export const Header = ({
  thread,
  hasNewMessage,
  onTrack,
  onScrollToLatestMessage,
  onHideNewMessage,
}: Props) => {
  const track = () => onTrack(!thread.tracked);

  return (
    <Menu borderless className="messages-header">
      <Menu.Item className="icon-container">
        <Link to="/threads" className="ui icon button">
          <Icon name="chevron left" />
        </Link>
      </Menu.Item>
      <Menu.Item header>{thread.user}</Menu.Item>
      <Menu.Menu position="right">
        {hasNewMessage && (
          <Menu.Item>
            <Label color="red">
              Nouveau(x) message(s) !
              <Icon name="close" onClick={onHideNewMessage} />
            </Label>
          </Menu.Item>
        )}
        <Menu.Item>
          <Rating icon="star" rating={thread.tracked ? 1 : 0} onClick={track} />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  );
};



// WEBPACK FOOTER //
// ./src/modules/messaging/components/messages/Header.js